import type { Colors, DefaultTheme } from 'styled-components';
import { setAlpha } from '../utils';
import { darkColors, mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  primary: {
    lighten: '#098300',
    default: '#29AC00',
    dim: setAlpha(0.4, '#29AC00'),
    mute: setAlpha(0.1, '#29AC00'),
  },
  gray: {
    main: '#191e23',

    '000': '#040405',
    '010': '#0b0b0b',
    '020': '#262b2f',
    '030': '#34393b',
    '040': '#424647',
    '050': '#494d4d',
    '060': '#525655',
    '070': '#626663',
    '080': '#8c8e88',
    '090': '#acaea4',
    '100': '#ffe',
  },
  green: {
    lighten: '#098300',
    default: '#68C74A',
    dim: setAlpha(0.4, '#68C74A'),
    mute: setAlpha(0.1, '#68C74A'),
  },
  red: {
    lighten: '#D11328',
    default: '#FD596B',
    dim: setAlpha(0.4, '#FD596B'),
    mute: setAlpha(0.1, '#FD596B'),
  },
  yellow: {
    lighten: '#d7bd66',
    default: '#CCAC3E',
    dim: 'rgba(204,172,62,0.4)',
    mute: 'rgba(204,172,62,0.1)',
  },
  orange: {
    lighten: '#ff6c1a',
    default: '#E65200',
    dim: 'rgba(230,82,0,0.4)',
    mute: 'rgba(230,82,0,0.1)',
  },
  purple: darkColors.purple,

  blue: {
    default: '#8FB4FF',
    lighten: '#437EFF',
    dim: setAlpha(0.4, '#8FB4FF'),
    mute: setAlpha(0.1, '#8FB4FF'),
  },

  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const DarkBitsoTheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkBso',

  backgroundNegativeButtonActive: colors.red.default,
  backgroundNegativeButtonFocus: colors.red.default,
  backgroundPositiveButtonActive: colors.green.default,
  backgroundPositiveButtonFocus: colors.green.default,
  backgroundPrimaryButtonActive: colors.primary.default,
  backgroundPrimaryButtonFocus: colors.primary.default,

  backgroundChartUpColor: colors.green.default,
  borderColorChartUpColor: colors.green.default,
  backgroundChartDownColor: colors.red.default,
  borderColorChartDownColor: colors.red.default,
});
